import React from 'react';

interface SectionProps {
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
  background?: 'white' | 'gray' | 'primary';
  spacing?: 'sm' | 'md' | 'lg';
  container?: 'narrow' | 'default' | 'wide' | 'full';
  centered?: boolean;
  className?: string;
}

const Section: React.FC<SectionProps> = ({
  title,
  subtitle,
  children,
  background = 'white',
  spacing = 'md',
  container = 'default',
  centered = false,
  className = '',
}) => {
  const bgClasses = {
    white: 'bg-white',
    gray: 'bg-gray-50',
    primary: 'bg-primary-light text-white',
  };

  const spacingClasses = {
    sm: 'py-12',
    md: 'py-16',
    lg: 'py-24',
  };

  const containerClasses = {
    narrow: 'max-w-3xl mx-auto px-4 md:px-8',
    default: 'max-w-6xl mx-auto px-4 md:px-8',
    wide: 'max-w-7xl mx-auto px-4 md:px-8',
    full: 'w-full px-4 md:px-8',
  };

  const centeredClasses = centered ? 'text-center' : '';

  const sectionClasses = `${bgClasses[background]} ${spacingClasses[spacing]} ${className}`;
  const contentClasses = `${containerClasses[container]} ${centeredClasses}`;

  return (
    <section className={sectionClasses}>
      <div className={contentClasses}>
        {title && (
          <h2 className="text-4xl md:text-5xl font-bold mb-4 font-serif">
            {title}
          </h2>
        )}
        {subtitle && (
          <p className="text-xl text-gray-600 mb-8">
            {subtitle}
          </p>
        )}
        {children}
      </div>
    </section>
  );
};

export default Section;

